"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countDecimals = countDecimals;
exports.roundToIncrement = roundToIncrement;
exports.truncate = truncate;
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _Tooltip = _interopRequireDefault(require("./Tooltip"));
/**
 * Determines the number of digits after the decimal place. Returns 0 if there are none.
 * @param {number} num any real number
 * @returns {number} - an integer denoting the number of decimal digits
 */


function countDecimals(num) {
  if (Math.floor(num) === num) return 0;
  return num.toString().split('.')[1].length;
}
/**
 * Rounds the given number to the closest increment. The increment can be any real number.
 * @param {number} num any real number
 * @param {number} inc any real number
 * @returns {number} - num rounded to the closest increment.
 */


function roundToIncrement(num, inc) {
  return Math.round(Math.round(num / (inc / 10)) / 10) * inc; // https://gordonlesti.com/inaccurate-rounding-with-decimal-digits/
}
/**
 * Set the number a string, truncate to the given decimal point, and cut off any extraneous decimal zeroes.
 * @param {number} num any real number
 * @param {number} decimals any integer
 * @returns {number} - num truncated to the decimals, plus any extra zeroes removed.
 */


function truncate(num, decimals) {
  // toFixed() solves the problem of floats (such as 1.0000000000000000012) being returned from increment.
  // the replace() will then determine if the result is a decimal with trailing zeroes, and remove the zeroes/decimal if applicable.
  return num.toFixed(decimals).replace(/\.\d*0+$/, function (match) {
    return match.replace(/\.?0+$/, '');
  });
}

var barWidth = 0;
var barLeft = 0;
var touchIdentifier = 0;

function getPosition(element) {
  var box = element.getBoundingClientRect();
  return {
    left: box.left + window.scrollX,
    top: box.top + window.scrollY,
    width: box.width,
    height: box.height
  };
}

function getMouseX(e) {
  // Regular mouse events.
  if (typeof e.pageX === 'number' && e.pageX === e.pageX) {
    // eslint-disable-line no-self-compare
    return e.pageX;
  } // Touch events.


  for (var i = 0; i < e.changedTouches.length; i += 1) {
    if (e.changedTouches[i].identifier === touchIdentifier) {
      return e.changedTouches[i].pageX;
    }
  }

  return 0; // It should never get here.
}

var Slider = function Slider(props) {
  // Destructure the props
  var value = props.value,
      label = props.label,
      min = props.min,
      max = props.max,
      disabled = props.disabled,
      increment = props.increment,
      selectOnDrag = props.selectOnDrag,
      onSelect = props.onSelect; // State setup

  var _useState = (0, _react.useState)(value),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      internalNumber = _useState2[0],
      setInternalNumber = _useState2[1];

  var _useState3 = (0, _react.useState)(value.toString()),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      displayString = _useState4[0],
      setDisplayString = _useState4[1];

  var _useState5 = (0, _react.useState)(value),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      roundedNumber = _useState6[0],
      setRoundedNumber = _useState6[1];

  var _useState7 = (0, _react.useState)(increment),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      decimals = _useState8[0],
      setDecimals = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      dragging = _useState10[0],
      setDragging = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      hover = _useState12[0],
      setHover = _useState12[1]; // Ref to the slider bar


  var sliderBarRef = (0, _react.useRef)(null);
  var left = "".concat(100 * ((internalNumber - min) / (max - min)), "%");
  var shouldFocus = hover || dragging;
  /* eslint-disable react-hooks/exhaustive-deps */

  (0, _react.useEffect)(function () {
    if (value !== roundedNumber) {
      setInternalNumber(value);
      setDisplayString(value.toString());
      setRoundedNumber(value);
    }

    setDecimals(countDecimals(increment));
  }, [value, increment]);
  (0, _react.useEffect)(function () {
    if (!dragging) {
      onSelect(roundedNumber);
    }
  }, [dragging]);

  var onDragMove = function onDragMove(e) {
    var mouseX = getMouseX(e);
    var nextInternalNumber;

    if (mouseX <= barLeft) {
      nextInternalNumber = min;
    } else if (mouseX >= barLeft + barWidth) {
      nextInternalNumber = max;
    } else {
      var range = max - min;
      var percentage = (mouseX - barLeft) / barWidth;
      nextInternalNumber = min + percentage * range;
    }

    var nextRoundedNumber = roundToIncrement(nextInternalNumber, increment);
    var nextDisplayString = truncate(nextRoundedNumber, decimals);
    setInternalNumber(nextInternalNumber);
    setRoundedNumber(nextRoundedNumber);
    setDisplayString(nextDisplayString);

    if (selectOnDrag && nextRoundedNumber !== value) {
      onSelect(nextRoundedNumber);
    }
  };

  var onDragEnd = function onDragEnd() {
    setDragging(false);
    document.removeEventListener('mousemove', onDragMove);
    document.removeEventListener('touchmove', onDragMove);
    document.removeEventListener('mouseup', onDragEnd);
    document.removeEventListener('touchend', onDragEnd);
  };

  var onDragStart = function onDragStart(e) {
    if (!disabled) {
      var barPosition = getPosition(sliderBarRef.current);
      barLeft = barPosition.left;
      barWidth = barPosition.width;

      if (e.targetTouches) {
        touchIdentifier = e.targetTouches[0].identifier;
      }

      setDragging(true);
      document.addEventListener('mousemove', onDragMove);
      document.addEventListener('touchmove', onDragMove);
      document.addEventListener('mouseup', onDragEnd);
      document.addEventListener('touchend', onDragEnd);
      onDragMove(e);
    }
  };

  var onMouseOver = function onMouseOver() {
    setHover(true);
  };

  var onMouseOut = function onMouseOut() {
    setHover(false);
  };

  return _react["default"].createElement("div", {
    className: (0, _emotion.cx)('slider', {
      'slider-focus': shouldFocus
    }),
    disabled: disabled,
    onMouseOver: onMouseOver,
    onFocus: onMouseOver,
    onMouseOut: onMouseOut,
    onBlur: onMouseOut
  }, _react["default"].createElement("div", {
    className: "slider-title"
  }, label), _react["default"].createElement("div", {
    ref: sliderBarRef,
    className: "slider-bar",
    onTouchStart: onDragStart,
    onMouseDown: onDragStart
  }, _react["default"].createElement("div", {
    className: "slider-progress-bar",
    style: {
      width: left
    }
  })), _react["default"].createElement("div", {
    className: "slider-handle",
    style: {
      left: left
    }
  }, _react["default"].createElement(_Tooltip["default"], {
    direction: "bottom",
    show: shouldFocus,
    variety: "popover",
    contents: displayString
  }, _react["default"].createElement("div", {
    className: "slider-virtual-handle",
    onMouseDown: onDragStart,
    onTouchStart: onDragStart
  }))), _react["default"].createElement("div", {
    className: "slider-values"
  }, _react["default"].createElement("div", {
    className: "slider-min"
  }, min), _react["default"].createElement("div", {
    className: "slider-max"
  }, max)));
};

Slider.propTypes = {
  label: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,
  onSelect: _propTypes["default"].func.isRequired,
  increment: _propTypes["default"].number,
  selectOnDrag: _propTypes["default"].bool
};
Slider.defaultProps = {
  disabled: false,
  increment: 1,
  min: 0,
  max: 100,
  selectOnDrag: false
};
var _default = Slider;
exports["default"] = _default;